import LayoutExample from 'pages/HyperFunnel/components/JourneyBuilder/Panel/Canvas/Layout';

export default function CanvasPanel() {
  return <LayoutExample />;
}
